import gql from 'graphql-tag';

import { Group } from './group';
import PublicUserProfile from './public_user_profile';
import ClientDepartment from './client_department';
import ClientLocation from './client_location';

export default gql`
  fragment UserSegment on UserSegment {
    id
    title
    created_at
    segment_status
    department_ids
    departments {
      ...ClientDepartment
    }
    location_ids
    locations {
      ...ClientLocation
    }
    group_ids
    groups {
      ...Group
    }
    registered_count
    third_party_count
  }
  ${Group}
  ${PublicUserProfile}
  ${ClientDepartment}
  ${ClientLocation}
`;
